/**
 * Currency utilities for EUR/BGN conversion
 * Fixed exchange rate: 1 EUR = 1.95583 BGN (Bulgaria's currency board)
 */

export const EUR_TO_BGN_RATE = 1.95583;

/**
 * Convert EUR to BGN
 * @param {number} eur - Amount in EUR
 * @returns {number} Amount in BGN
 */
export const eurToBgn = (eur) => {
    if (!eur || isNaN(eur)) return 0;
    return eur * EUR_TO_BGN_RATE;
};

/**
 * Convert BGN to EUR
 * @param {number} bgn - Amount in BGN
 * @returns {number} Amount in EUR
 */
export const bgnToEur = (bgn) => {
    if (!bgn || isNaN(bgn)) return 0;
    return bgn / EUR_TO_BGN_RATE;
};

/**
 * Format price with both EUR and BGN
 * @param {number} priceEur - Price in EUR
 * @param {object} options - Formatting options
 * @returns {string} Formatted price string
 */
export const formatDualPrice = (priceEur, options = {}) => {
    const { showBgn = true, eurFirst = true } = options;
    
    if (!priceEur || isNaN(priceEur)) return '0.00 €';
    
    const eurFormatted = priceEur.toFixed(2);
    const bgnFormatted = eurToBgn(priceEur).toFixed(2);
    
    if (!showBgn) {
        return `${eurFormatted} €`;
    }
    
    if (eurFirst) {
        return `${eurFormatted} € (${bgnFormatted} лв.)`;
    }
    return `${bgnFormatted} лв. (${eurFormatted} €)`;
};

/**
 * Price display component helper - returns object with both values
 * @param {number} priceEur - Price in EUR
 * @returns {object} { eur, bgn, eurFormatted, bgnFormatted }
 */
export const getPriceData = (priceEur) => {
    const eur = priceEur || 0;
    const bgn = eurToBgn(eur);
    return {
        eur,
        bgn,
        eurFormatted: eur.toFixed(2),
        bgnFormatted: bgn.toFixed(2)
    };
};
